const ConfigService = {
  isLocalMode (configVar) {
    return ~encodeURIComponent(configVar).indexOf('%23%7B')
  }
}

export default ConfigService
